export const errorMessage = (message) =>
  `<p class="error-message">${message}</p>`;
